export default {
  AUTH_TOKEN: 'token',
}
